import { Box, Chip, Stack, Typography } from '@mui/material';

const REQUIRED_TYPES = ['iq', 'oq', 'pq'];

function daysUntil(dateStr) {
  if (!dateStr) return Infinity;
  const target = new Date(dateStr);
  target.setHours(0, 0, 0, 0);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return Math.floor((target - today) / 86400000);
}

function pickBadgeColor(daysLeft) {
  if (daysLeft === Infinity) return { color: 'success', label: '∞' };
  if (daysLeft < 0) return { color: 'default', label: 'expired' };
  if (daysLeft <= 30) return { color: 'error', label: `${daysLeft}d` };
  if (daysLeft <= 60) return { color: 'warning', label: `${daysLeft}d` };
  return { color: 'success', label: `${daysLeft}d` };
}

export default function ValidationStatusBlock({ machine, t }) {
  const group = machine?.machine_group;
  if (!group) return null;
  const requiredKinds = REQUIRED_TYPES.filter((k) => group[`requires_${k}`]);
  if (requiredKinds.length === 0) return null;

  const docs = (machine?.validation_documents || []).filter((d) => d?.type);
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return (
    <Box sx={{ mb: 2, p: 1.5, borderRadius: 1, border: '1px solid var(--table-border)' }}>
      <Typography variant="body2" fontWeight="bold" sx={{ mb: 1 }}>
        {t('validation.coverage')}
      </Typography>
      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
        {requiredKinds.map((kind) => {
          const matching = docs
            .filter((d) => d.type === kind)
            .map((d) => ({ ...d, daysLeft: daysUntil(d.expires_at) }))
            .sort((a, b) => a.daysLeft - b.daysLeft);
          const best = matching.find((d) => d.daysLeft >= 0) || matching[0];
          if (!best) {
            return (
              <Chip
                key={kind}
                size="small"
                color="error"
                variant="outlined"
                label={`${t(`validation.${kind}`)}: ${t('validation.missing')}`}
              />
            );
          }
          const badge = pickBadgeColor(best.daysLeft);
          const expiryStr = best.expires_at
            ? new Date(best.expires_at).toISOString().slice(0, 10)
            : t('validation.neverExpires');
          return (
            <Chip
              key={kind}
              size="small"
              color={badge.color}
              label={`${t(`validation.${kind}`)}: ${expiryStr} (${badge.label})`}
            />
          );
        })}
      </Stack>
    </Box>
  );
}
